export default "__VITE_ASSET__DEY_xdax__"